<script lang="ts">
  import {
    getSingleProductStyle,
    styleToString,
  } from "@shared/common/node/style";
  import type {
    ISingleProductNode,
    PartialNode,
  } from "@shared/common/node/type";
  import { SyncType } from "@shared/common/schema/store";
  import type { ISingleProductData } from "@shared/common/types/data-source";
  import { getSingleProductDataAlias } from "@shared/common/utils/data-source";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";

  const { onImpressionEvent, rootShown, reactionEventListener, dataMap } =
    getStore();

  const documentNode = getCurrentDocumentNode();

  export let wrapperType: "iframe" | "embedded";
  export let node: PartialNode<ISingleProductNode>;
  export let depth: number;
  const productAlias =
    node.originalId && node.originalStoreId && node.vendorType
      ? getSingleProductDataAlias({
          externalId: node.originalId,
          originalStoreId: node.originalStoreId,
          originalSubstoreId: node.originalSubstoreId ?? null,
          syncType: SyncType.Product,
          vendorType: node.vendorType,
        })
      : "";

  $: product = ($dataMap[productAlias] as ISingleProductData | undefined)?.data;

  wrapperType;
  depth;
  onImpressionEvent;
  rootShown;
</script>

<div
  style={`${styleToString(getSingleProductStyle(node))} z-index: 0;`}
  class="aspect-ratio"
  use:detectReaction={{
    node,
    onAction: reactionEventListener,
    documentNode,
  }}
>
  {#if product}
    <div style="display: flex">
      <div>
        <img src={product.image} alt="" />
      </div>
      <div>
        <p>이름: {product.title}</p>
        <p>가격: {product.price}원</p>
      </div>
    </div>
  {:else}
    <div>노상품</div>
  {/if}

  <!-- {product ? (
        <div style={{ display: "flex" }}>
          <div>
            <img src={product.imageUrl} />
          </div>
          <div>
            <p>이름: {product.title}</p>
            <p>가격: {product.price}원</p>
          </div>
        </div>
      ) : (
        "상품을 선택해주세요."
      )} -->

  <!-- <swiper-container
    bind:this={swiperEl}
    init={false}
    style={node.autoHeight
      ? ""
      : "width: 100%; height: 100%; position:absolute; top:0; left:0;"}
  >
    {#each $childrenNodeData || [] as child, index}
      <SwiperSlide node={child} {index}>
        <Node node={child} {depth} {wrapperType} />
      </SwiperSlide>
    {/each}
  </swiper-container> -->
</div>

<style>
  .aspect-ratio::before {
    content: "";
    padding-top: var(--cb-before-padding-top);
    float: left;
  }

  .aspect-ratio::after {
    clear: left;
    content: " ";
    display: table;
  }
</style>
